import React, { useState } from 'react';
import Papa from 'papaparse';
import { Form, FormGroup, Input, Table, Col, Row, Button, CustomInput, Popover, PopoverBody } from "reactstrap";

const   LayoutFileForm = ({setLayout, closeModal}) => {
  const [showFileUpload, setShowFileUpload] = useState(true);
  const [showUserSelction, setShowUserSelection] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [popOverOpen, setPopoverOpen] = useState(false);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [tableBody, setTableBody] = useState([]);
  const [previewTable, setPreviewTable] = useState([]);
  const [layoutHeaders, setLayoutHeaders] = useState({});
  const header = [];
  const inputs = ['brandSelect', 'cardTypeSelect', 'codeSelect', 'activationCodeSelect', 'pinSelect', 'expirationDateSelect'];
  const brandColor = 'bg-color1';
  const cardTypeColor = 'bg-color3';
  const codeColor = 'bg-color5';
  const activationCodeColor = 'bg-color2';
  const pinColor = 'bg-color4';
  const expirationDateColor = 'bg-color6';
  const headerColors = [brandColor, cardTypeColor, codeColor, activationCodeColor, pinColor, expirationDateColor];

  const parseCSV = (e) => {
    e.preventDefault();
    
    if(document.getElementById('csvLayoutFile').files[0]){
      if(document.getElementById('headersIncluded').checked){
        Papa.parse(document.getElementById('csvLayoutFile').files[0],
          {
            download: true,
            header: true,
            complete: (result) => {
              setTableHeaders(result.meta.fields);
              setTableBody(result.data);
              setShowTable(true);
              setShowFileUpload(false);
              result.meta.fields.map(column => header.push({title: column, data: column}));
            }
          },
        );  
      } else {
        Papa.parse(document.getElementById('csvLayoutFile').files[0],
          {
            download: true,
            header: false,
            complete: (result) => {
              const charCodes = Array.from(Array(result.data[0].length)).map((e, i) => i + 65);
              let columnsFromAlphabet = charCodes.map((x) => String.fromCharCode(x));
              setTableHeaders(columnsFromAlphabet);
              let array = result.data;
              array.unshift(columnsFromAlphabet);
              let csv = Papa.unparse(array);
              Papa.parse(csv,
                {
                  header: true,
                  complete: (result) => {
                    setTableBody(result.data);
                  }
                }
              );
              setShowTable(true);
              setShowFileUpload(false)
            }
          },
        );  
      }
      
    }
  }

  const rePaintHeaders = () => {
    tableHeaders.map(header => {
      document.getElementById(header).classList.remove(...headerColors);
      return null;
    });

    inputs.map(input => {
      if(document.getElementById(input).value !== 'notAvailable' && document.getElementById(input).value !== ''){
        switch (document.getElementById(input).id) {
          case 'brandSelect':
            document.getElementById(document.getElementById(input).value).classList.add(brandColor);
            break;
          case 'cardTypeSelect':
            document.getElementById(document.getElementById(input).value).classList.add(cardTypeColor);
            break;
          case 'codeSelect':
            document.getElementById(document.getElementById(input).value).classList.add(codeColor);
            break;
          case 'activationCodeSelect':
            document.getElementById(document.getElementById(input).value).classList.add(activationCodeColor);
            break;
          case 'pinSelect':
            document.getElementById(document.getElementById(input).value).classList.add(pinColor);
            break;
          case 'expirationDateSelect':
            document.getElementById(document.getElementById(input).value).classList.add(expirationDateColor);
            break;
        
          default:
            break;
        }
      }
      return null;
    });
  }

  const colorHeader = (e) => {
    if(e.target.value !== 'notAvailable' && e.target.value !== ''){
      inputs.map(input => {
        if(document.getElementById(input).value === e.target.value){
          if(document.getElementById(input) !== e.target){
            document.getElementById(input).value = '' ;
          }
        }
        
        return null;
      });

      rePaintHeaders();
    } else {
      rePaintHeaders();
    }
  }

  const displayPreview = (e) => {
    e.preventDefault();
    if(document.getElementById('csvLayoutFile').files[0]){
      Papa.parse(document.getElementById('csvLayoutFile').files[0],
        {
          download: true,
          header: false,
          complete: (result) => {
            setPreviewTable(result.data);
            setShowPreview(true);
          }
        }
      );
    }
  }

  const submitLayout = (e) => {
    if(!inputs.every(input => document.getElementById(input).value !== '')){
      e.preventDefault();
      setPopoverOpen(true);
      setTimeout(() => {setPopoverOpen(false)}, 3000);
    } else {
      setLayout({
        brand: document.getElementById('brandSelect').value === 'notAvailable' ? 'notAvailable' : document.getElementById(document.getElementById('brandSelect').value).dataset.index,
        cardType: document.getElementById('cardTypeSelect').value === 'notAvailable' ? 'notAvailable' : document.getElementById(document.getElementById('cardTypeSelect').value).dataset.index,
        data: {
          code: document.getElementById('codeSelect').value === 'notAvailable' ? 'notAvailable' : document.getElementById(document.getElementById('codeSelect').value).dataset.index,
          activationCode: document.getElementById('activationCodeSelect').value === 'notAvailable' ? 'notAvailable' : document.getElementById(document.getElementById('activationCodeSelect').value).dataset.index,
          PIN: document.getElementById('pinSelect').value === 'notAvailable' ? 'notAvailable' : document.getElementById(document.getElementById('pinSelect').value).dataset.index,
        },
        expirationDate: document.getElementById('expirationDateSelect').value === 'notAvailable' ? 'notAvailable' : document.getElementById(document.getElementById('expirationDateSelect').value).dataset.index,
      });
      setLayoutHeaders({
        brand: document.getElementById('brandSelect').value === 'notAvailable' ? 'Not available' : document.getElementById(document.getElementById('brandSelect').value).innerHTML,
        cardType: document.getElementById('cardTypeSelect').value === 'notAvailable' ? 'Not available' : document.getElementById(document.getElementById('cardTypeSelect').value).innerHTML,
        data: {
          code: document.getElementById('codeSelect').value === 'notAvailable' ? 'Not available' : document.getElementById(document.getElementById('codeSelect').value).innerHTML,
          activationCode: document.getElementById('activationCodeSelect').value === 'notAvailable' ? 'Not available' : document.getElementById(document.getElementById('activationCodeSelect').value).innerHTML,
          PIN: document.getElementById('pinSelect').value === 'notAvailable' ? 'Not available' : document.getElementById(document.getElementById('pinSelect').value).innerHTML,
        },
        expirationDate: document.getElementById('expirationDateSelect').value === 'notAvailable' ? 'Not available' : document.getElementById(document.getElementById('expirationDateSelect').value).innerHTML,
      });
      setShowUserSelection(true);
      setShowTable(false);
      setShowFileUpload(false);
    }
  }

  return (
    <>
      { showFileUpload && 
        <Row className="justify-content-center mt-4">
          <Col md={10}>
            <Form>
              <legend>
                Upload .csv file.
              </legend>


              
              <FormGroup tag="fieldset">
                <CustomInput id="csvLayoutFile" type="file" name="type" label="choose file..." accept=".csv" onChange={displayPreview} />
              </FormGroup>

              { showPreview &&
                <div style={{overflowY: 'hidden', overflowX: 'auto'}}>
                  <table className="table table-striped">
                    <tbody>
                      <tr>{
                        previewTable[0].map((item, index) => (
                          <>
                            <td key={index} title={item} className="text-truncate text-center" style={{maxWidth: '90px'}}> {item}</td>
                          </>
                        ))}
                      </tr>
                      <tr>{
                        previewTable[1].map((item, index) => (
                            <td key={index} title={item} className="text-truncate text-center" style={{maxWidth: '90px'}}>{item}</td>
                        ))}
                      </tr>
                      <tr>{
                        previewTable[1].map((item, index) => (
                            <td key={index} title={item} className="text-truncate text-center" style={{maxWidth: '90px'}}>{item}</td>
                        ))}
                      </tr>
                        
                    </tbody>
                  </table>
                </div>
              }

              <FormGroup>
							  <CustomInput id="headersIncluded" type="checkbox" name="type" label="File has headers" />
					  	</FormGroup>

              <FormGroup check row >
                <Col sm={{ offset: 0, size: 10 }} >
                  <Button className="btn btn-primaryTwo" onClick={parseCSV}>
                    Next
                  </Button>
                </Col>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      }

      {showTable && 
        <>
          <Row className="justify-content-center">
            <Col md={12}>
              <button type="button" className="btn btn-link"
                onClick={() => {
                  setShowTable(false);
                  setShowFileUpload(true);
                  setShowPreview(false);
                }}>
                  <i className="fas fa-angle-double-left" /> Go back</button>
            </Col>
            
          </Row>
          
          <Row className="justify-content-center mt-4">
            <Col md={10}>
              <div style={{overflowY: 'hidden', overflowX: 'auto'}}>
              <table className="table table-striped">
                <thead>
                  <tr id="tableHeaders">
                    {
                      tableHeaders.map((header, index) => (<th className="text-center" id={`${header}`} data-index={index} key={index}>{header}</th>))
                    }
                  </tr>
                </thead>
                <tbody>
                  <tr>{
                    tableHeaders.map((header, index) => (
                      <>
                        <td key={index} title={tableBody[0][header]} className="text-truncate text-center" style={{maxWidth: '90px'}}> {tableBody[0][header]}</td>
                      </>
                    ))}
                  </tr>
                  <tr>{
                    tableHeaders.map((header, index) => (
                        <td key={index} title={tableBody[0][header]} className="text-truncate text-center" style={{maxWidth: '90px'}}>{tableBody[1][header]}</td>
                    ))}
                  </tr>
                    
                </tbody>
              </table>
              </div>

            </Col>
          </Row>
          
          <Row className="justify-content-center mt-2">
            <Col md={12}>
              <Form>

                <Row className="justify-content-center mt-2">
                  <Col md={5} className="pr-0">
                    <Table >
                      <tbody>
                        <tr className={brandColor}>
                          <th >
                            Brand
                          </th>
                          <td>
                            <Input id="brandSelect" name="select" type="select" onChange={colorHeader}>
                              <option defaultValue value="">select an option</option>
                              {
                                tableHeaders.map((header, index) => (
                                  <option key={index} value={header}>{header}</option>
                                ))
                              }
                              <option value={'notAvailable'}>not available in file</option>
                            </Input>
                          </td>
                        </tr>
                        <tr className={cardTypeColor}>
                          <th>
                            Card Type
                          </th>
                          <td>
                            <Input id="cardTypeSelect" name="select" type="select" onChange={colorHeader}>
                              <option defaultValue value="">select an option</option>
                              {
                                tableHeaders.map((header, index) => (
                                  <option key={index} value={header}>{header}</option>
                                ))
                              }
                              <option value={'notAvailable'}>not available in file</option>
                            </Input>
                          </td>
                        </tr>
                        <tr className={codeColor}>
                          <th>
                            Code
                          </th>
                          <td>
                            <Input id="codeSelect" name="select" type="select" onChange={colorHeader}>
                              <option defaultValue value="">select an option</option>
                              {
                                tableHeaders.map((header, index) => (
                                  <option key={index} value={header}>{header}</option>
                                ))
                              }
                              <option value={'notAvailable'}>not available in file</option>
                            </Input>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col md={5} className="pl-0">
                    <Table >
                      <tbody>

                      <tr className={activationCodeColor}>
                        <th>
                          Activation Code
                        </th>
                        <td>
                          <Input id="activationCodeSelect" name="select" type="select" onChange={colorHeader}>
                            <option defaultValue value="">select an option</option>
                            {
                              tableHeaders.map((header, index) => (
                                <option key={index} value={header}>{header}</option>
                              ))
                            }
                            <option value={'notAvailable'}>not available in file</option>
                          </Input>
                        </td>
                      </tr>
                      <tr className={pinColor}>
                        <th>
                          Pin
                        </th>
                        <td>
                          <Input id="pinSelect" name="select" type="select" onChange={colorHeader}>
                            <option defaultValue value="">select an option</option>
                            {
                              tableHeaders.map((header, index) => (
                                <option key={index} value={header}>{header}</option>
                              ))
                            }
                            <option value={'notAvailable'}>not available in file</option>
                          </Input>
                        </td>
                      </tr>
                      <tr className={expirationDateColor}>
                        <th>
                          Expiration date
                        </th>
                        <td>
                          <Input id="expirationDateSelect" name="select" type="select" onChange={colorHeader}>
                            <option defaultValue value="">select an option</option>
                            {
                              tableHeaders.map((header, index) => (
                                <option key={index} value={header}>{header}</option>
                              ))
                            }
                            <option value={'notAvailable'}>not available in file</option>
                          </Input>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                </Row>


                <FormGroup check row >
                  <Col sm={{ offset: 5, size: 10 }} >
                    <Button id="submitLayoutForm" color="primary" onClick={submitLayout}>
                      Save Layout
                    </Button>
                    <Popover
                      flip
                      target="submitLayoutForm"
                      isOpen={popOverOpen}
                      className="bg-warning"
                      
                    >
                      <PopoverBody className="bg-color3">
                        it apears some fields above are empty.
                      </PopoverBody>
                    </Popover>
                    
                  </Col>
                </FormGroup>
              </Form>
            </Col>
          </Row>

        </>
      }
      {
        showUserSelction && 
        <>
          <Row className="justify-content-center">
            <Col md={12}>
              <button type="button" className="btn btn-link"
                onClick={() => {
                  setShowTable(true);
                  setShowFileUpload(false);
                  setShowPreview(false);
                  setShowUserSelection(false)
                }}>
                  <i className="fas fa-angle-double-left" /> Go back</button>
            </Col>
            
          </Row>
          <Row className="justify-content-center mt-2 mx-4">
            <Col md={4} className="pr-0">
              <Table >
                <tbody>
                  <tr className={brandColor}>
                    <th >
                      Brand
                    </th>
                    <td>
                      {layoutHeaders.brand}  
                    </td>
                  </tr>
                  <tr className={cardTypeColor}>
                    <th >
                      Card Type
                    </th>
                    <td>
                      {layoutHeaders.cardType}  
                    </td>
                  </tr>
                  <tr className={codeColor}>
                    <th >
                      Code
                    </th>
                    <td>
                      {layoutHeaders.data.code}  
                    </td>
                  </tr>
                  <tr className={activationCodeColor}>
                    <th >
                      Activation Code
                    </th>
                    <td>
                      {layoutHeaders.data.activationCode}  
                    </td>
                  </tr>
                  <tr className={pinColor}>
                    <th >
                      Pin
                    </th>
                    <td>
                      {layoutHeaders.data.PIN}  
                    </td>
                  </tr>
                  <tr className={expirationDateColor}>
                    <th >
                      Expiration Date
                    </th>
                    <td>
                      {layoutHeaders.expirationDate}  
                    </td>
                  </tr>
                        
                </tbody>
              </Table>
            </Col>
                 
          </Row>
        </>

      }
      
    </>
  );
}
 
export default LayoutFileForm;